import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import styles from './NspkQrPage.module.scss'
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import InputBase from '@material-ui/core/InputBase';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import CircularProgress from '@material-ui/core/CircularProgress'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

// import Icon from '@material-ui/core/Icon';
import ListItemText from '@material-ui/core/ListItemText';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import QRCode from 'qrcode.react';

const SUBPAGE_COMPLETE = 'complete';
const SUBPAGE_FAILED = 'failed';
const SUBPAGE_PENDING = 'pending';

function isMobile() {
    const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}

/*
function isiOs() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}
*/

function intentLink(bank, url) {
    return url.replace('https://', bank['schema'] + '://');

    /*
    if (isiOs())  {    
        return this.iOS ? "".concat(this.QRData.replace("https:", bank['schema'] + ":")) : "".concat(this.QRData.replace("https:", "intent:"), "#Intent;scheme=").concat(t, ";package=").concat(bank['package_name'], ";end;")
    } else {
        return url.replace('https://', bank['schema'] + '://');
    }
    */
}

function ListItemLink(props) {
    return <ListItem button component="a" {...props} />;
}

function currentSubpageLocalStorageKey(urlParams) {
    return 'currentSubpage_' + urlParams['invoice_id'];
}

function payHereLocalStorageKey(urlParams) {
    return 'payHere_' + urlParams['invoice_id'];
}

export const NspkQrPage = () => {
    // парамеры из URL
    const urlSearchParams = new URLSearchParams(window.location.search);
    const urlParams = {}

    for (const key of urlSearchParams.keys()) {
        urlParams[key] = urlSearchParams.get(key)
    }
    // end: параметры иp URL
    // обновление статуса
    const intervalIdRef = useRef(null);
    const [isStatusFetching, setIsStatusFetching] = useState(false);
    const fetchStatus = async () => {
        await axios.post('/form/status', {
            invoice_id: urlParams['invoice_id'],
            merchant_id: urlParams['merchant_id'],
            endpoint_id: urlParams['endpoint_id'],
            signature: urlParams['status_signature']
        })
        .then(function (response) {
            if (response?.data?.payment_status != 'pending') {
                if (response.data?.finish_url && !response.data.finish_url?.startsWith('?')) {
                    window.location.href = response.data.finish_url;
                } else if (response?.data?.payment_status == 'complete') {
                    setCurrentSubpage(SUBPAGE_COMPLETE);
                } else if (response?.data?.payment_status == 'failed') {
                    setCurrentSubpage(SUBPAGE_FAILED);
                } else {
                    console.log("Unknown status: " + response?.data?.payment_status);
                }
                // может вызываться 2 раза (второй в useEffect), но это не проблема
                clearInterval(intervalIdRef.current);                
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    };
    const startStatusFetching = () => {
        // Fetch data initially
        fetchStatus();

        // Set up the interval to fetch data periodically
        intervalIdRef.current = setInterval(fetchStatus, 5000); // 5000 ms = 5 seconds
        setIsStatusFetching(true);
    };

    useEffect(() => {
        // Clean up the interval on component unmount
        return () => clearInterval(intervalIdRef.current);
    }, []);
    // end: обновление статуса

    const url = window.location.href;
    const [banksData, setBanksData] = useState({})
    const [bankFilter, setBankFilter] = useState('');

    // скрыть QR-код и показать список банков для оплаты
    const [payHere, setPayHere] = useState(() => {
        return localStorage.getItem(payHereLocalStorageKey(urlParams)) || false;
    });
    useEffect(() => {
        localStorage.setItem(payHereLocalStorageKey(urlParams), payHere);
    }, [payHere]);

    // статус платежа
    const [currentSubpage, setCurrentSubpage] = useState(() => {
        return localStorage.getItem(currentSubpageLocalStorageKey(urlParams)) || false;
    });

    useEffect(() => {
        localStorage.setItem(currentSubpageLocalStorageKey(urlParams), currentSubpage);
        if (currentSubpage == SUBPAGE_PENDING) {
            startStatusFetching()
        }
    }, [currentSubpage]);

    /*
    useEffect(() => {
        const origFontStyle = document.body.style.fontSize;
        // document.body.setAttribute('class', 'body-nspk-qr');
        return () => document.body.style.fontSize = origFontStyle;
    }, []);
    */

    useEffect(() => {
        fetch('https://qr.nspk.ru/proxyapp/c2bmembers.json')
          .then(response => response.json())
          .then(json => setBanksData(json))
          .catch(error => console.error(error));
      }, []);

    const handleBankClick = (bank, url) => {
        setCurrentSubpage(SUBPAGE_PENDING);
        
        try {            
            window.location.href = url;
        } catch (error) {
            alert('Не удалось загрузить банк клиент, пожалуйста проверьте, что он установлен (' + bank.bankName + ')');
        }
    }

    var banks = []
    if (banksData['dictionary']) {
        banks = banksData['dictionary'].filter(
            bank => bank.bankName.toLowerCase().includes(bankFilter) || bankFilter === ''
        ).map((bank, index) => (
            // <ListItemLink key={index} href={intentLink(bank, urlParams['qrdata'])}>
            <ListItemLink key={index} onClick={() => handleBankClick(bank, intentLink(bank, urlParams['qrdata']))}>
                <img className={styles.bankLogo} src={bank.logoURL} alt="" />
                <ListItemText> {bank.bankName} </ListItemText>
                <ListItemSecondaryAction>
                    <ChevronRightIcon className={styles.bankLinkArrow} fontSize="small" />
                </ListItemSecondaryAction>                    
            </ListItemLink>
        ));
    }

    var sbpLogo = (
        <div className={styles.logo}>
        <svg viewBox="0 0 400 200" fill="none"><path fill="#2A273F" fillRule="evenodd" d="M355.3 53.1v49.7h-17.5V68H321v34.8h-17.5V53.1h51.8ZM295 80.7c0 14.5-12 24-28.3 24-16.7 0-29-10-29-33 0-19.6 12.6-35.8 31.1-36 8.2 0 25.6-.5 25.6-.5l-7.8 14.5h-15.8c-8 0-15.3 6-16.3 14.3 4.3-4 10-6.3 16.8-6.3 14.8 0 23.7 9 23.7 23Zm-18 0c0-6.5-4.2-10.3-10.2-10.3-6.2 0-10.4 4-10.4 10.4 0 6.1 4.2 10.6 10.4 10.6 6.5 0 10.2-4.8 10.2-10.7ZM223.6 87.7s-4.2 2.4-10.5 2.9c-7.3.2-13.8-4.3-13.8-12.3 0-7.8 5.7-12.3 13.6-12.3 4.8 0 11.2 3.3 11.2 3.3l7-12.6c-4.4-3.3-10.3-5.1-17.1-5.1-17.3 0-30.7 11-30.7 26.6 0 15.7 12.6 26.5 30.7 26.2 5-.2 12-2 16.3-4.6l-6.7-12Z" clipRule="evenodd"></path><path fill="#605CA4" fillRule="evenodd" d="m0 43.4 24.2 43.2v26.3L0 155.9V43.5Z" clipRule="evenodd"></path><path fill="#DA2157" fillRule="evenodd" d="M93 70.8 115.9 57h46.5L93 99V70.9Z" clipRule="evenodd"></path><path fill="#FAB828" fillRule="evenodd" d="M93 43.2v57.1L69 85.4V0l24 43.2Z" clipRule="evenodd"></path><path fill="#EE7332" fillRule="evenodd" d="M162.3 56.9h-46.5L93 43.1 69 0l93.4 56.9Z" clipRule="evenodd"></path><path fill="#66B438" fillRule="evenodd" d="M93 156.2v-27.8L69 113.8v85.6L93 156.2Z" clipRule="evenodd"></path><path fill="#208ACA" fillRule="evenodd" d="m115.8 142.5-91.5-56L0 43.5l162.3 99h-46.5Z" clipRule="evenodd"></path><path fill="#1B823E" fillRule="evenodd" d="m68.9 199.4 24.3-43.2 22.6-13.7h46.5l-93.4 56.9Z" clipRule="evenodd"></path><path fill="#9A4F98" fillRule="evenodd" d="m0 156 69.2-42.1-23.3-14.2-21.6 13.2-24.3 43Z" clipRule="evenodd"></path><path fill="#2A273F" fillRule="evenodd" d="M200.6 136.6a5 5 0 0 1-2 1.5 7.8 7.8 0 0 1-5.5 0 6.1 6.1 0 0 1-3.6-3.3c-.3-.8-.5-1.7-.5-2.7 0-1 .2-1.8.5-2.6a6.3 6.3 0 0 1 5.9-4c1 0 2 .1 2.8.4a5 5 0 0 1 2.2 1.2l-1 1.8c-.6-.5-1.2-.8-1.8-1-.6-.2-1.2-.3-1.9-.3a4.3 4.3 0 0 0-3 1.2l-1 1.4c-.2.6-.3 1.2-.3 1.9s.1 1.3.3 1.8l1 1.5a5 5 0 0 0 6.8-.4l1.1 1.6ZM203.5 138.4v-12.6h2.2v9.4l7.2-9.4h2.2v12.6h-2.2V129l-7.2 9.4h-2.2ZM230.2 136.6a5 5 0 0 1-2.1 1.5 7.8 7.8 0 0 1-5.5 0 6.1 6.1 0 0 1-3.6-3.3 7.2 7.2 0 0 1 1.4-7.4 6.4 6.4 0 0 1 4.6-2c1 0 1.9.2 2.8.5a5 5 0 0 1 2.1 1.2l-1 1.8c-.5-.5-1.1-.8-1.7-1-.6-.2-1.3-.3-2-.3a4.3 4.3 0 0 0-3 1.2l-1 1.4c-.1.6-.3 1.2-.3 1.9s.2 1.3.4 1.8l1 1.5c.4.4.9.7 1.4.9a5 5 0 0 0 3.9-.2 5 5 0 0 0 1.5-1.2l1 1.7ZM231.1 125.8h11.7v2.2H238v10.4h-2.3V128h-4.7v-2.2ZM255.4 137a6 6 0 0 1-2.2 1.3 8.6 8.6 0 0 1-5.5 0 5.9 5.9 0 0 1-3.6-3.4c-.2-1-.4-1.8-.4-2.8 0-1 .2-1.8.5-2.6a6 6 0 0 1 3.3-3.5 7.2 7.2 0 0 1 5.2-.1 5.7 5.7 0 0 1 3.1 3c.3.7.5 1.5.5 2.4 0 .5 0 1-.2 1.5h-9.8c0 1.2.5 2.1 1.3 2.8.9.6 1.9 1 3.2 1 .8 0 1.6-.2 2.2-.4a5 5 0 0 0 1.7-1l.7 1.8Zm-5.2-9.4a4 4 0 0 0-2.8 1c-.7.6-1.1 1.4-1.3 2.4h7.8c0-1.1-.4-2-1-2.5-.7-.6-1.6-1-2.7-1ZM259.1 125.8h2l5 6.2 4.5-6.2h2v12.6h-2.2v-9.2L266 135l-4.6-5.8v9.2H259v-12.6ZM276.8 126.6a8.5 8.5 0 0 1 4.2-1.1c1.8 0 3 .4 3.8 1.3.7.9 1 2.1 1 3.8v7.6h-2v-1.6a5 5 0 0 1-1.6 1.2c-.6.4-1.5.6-2.5.6a4 4 0 0 1-2.8-1c-.8-.7-1.1-1.7-1.1-2.9 0-.6.1-1.2.4-1.7.2-.5.5-.9 1-1.2.4-.3.9-.6 1.5-.8l1.9-.2 1.6.1c.6.2 1.1.4 1.5.7v-1.6l-.5-1.3a2 2 0 0 0-.8-.8l-1.5-.2c-.8 0-1.5 0-2 .2l-1.5.7-.6-1.8Zm3.7 9.8c.8 0 1.5-.2 2-.5l1.2-1.1v-1.6a4.8 4.8 0 0 0-3.8-.7c-.3 0-.6.2-.9.4l-.6.6-.2 1c0 .5.2 1 .6 1.3.4.4 1 .6 1.7.6ZM306.9 120.3c-.4.5-.8.9-1.3 1l-1.5.6-1.7.3c-.6 0-1.3.3-2 .6a4 4 0 0 0-1.4 1 6 6 0 0 0-1 1.6l-.5 1.7-.3 1.8c.3-.5.6-.9 1-1.2a5.7 5.7 0 0 1 2.5-1.5c.5-.2 1-.2 1.6-.2.9 0 1.7.1 2.4.4a5.1 5.1 0 0 1 3 3.3 7.6 7.6 0 0 1 0 5 6.3 6.3 0 0 1-6 4c-1 0-2-.2-2.8-.6a6 6 0 0 1-2.1-1.5 7 7 0 0 1-1.4-2.5c-.3-1-.4-2-.4-3.2l.1-3c.1-1 .4-2 .7-2.9.4-1 .8-1.8 1.4-2.5.6-.8 1.5-1.4 2.5-1.8l2-.6a279.6 279.6 0 0 0 2.9-.7c.4-.1.8-.4 1-.8l1.3 1.7Zm-9.5 11c0 .8 0 1.5.3 2.2l.8 1.6a4 4 0 0 0 3.1 1.5 4.1 4.1 0 0 0 3-1.3c.4-.3.7-.8.9-1.3.2-.5.3-1 .3-1.7 0-1.2-.4-2.2-1-3-.8-.8-1.8-1.2-3-1.2a4.6 4.6 0 0 0-4 2l-.4 1.2ZM311.3 125.8h2.2v3.8h2.1c1 0 1.8 0 2.4.3a4 4 0 0 1 1.5 1c.4.4.7.8.8 1.4a5.6 5.6 0 0 1 0 3.2c-.2.6-.5 1-.9 1.5-.4.4-1 .7-1.6 1-.6.2-1.5.4-2.4.4h-4v-12.6Zm2.2 5.9v4.6h1.7c1 0 1.8-.2 2.3-.6.5-.4.7-1 .7-1.7 0-.8-.2-1.4-.7-1.8-.5-.3-1.2-.5-2.3-.5h-1.7Zm9.4-6h2.3v12.7h-2.3v-12.6ZM340 136.6a5 5 0 0 1-2.2 1.5c-.8.4-1.8.6-2.7.6-1 0-2-.2-2.8-.5a6 6 0 0 1-3.5-3.4c-.3-.8-.5-1.7-.5-2.7 0-1 .2-1.8.5-2.6a6.3 6.3 0 0 1 6-4c1 0 1.9.1 2.7.4a5 5 0 0 1 2.2 1.2l-1 1.8c-.6-.5-1.2-.8-1.8-1-.6-.2-1.2-.3-1.9-.3a4.3 4.3 0 0 0-3 1.2l-1 1.4c-.2.6-.3 1.2-.3 1.9s.1 1.3.4 1.8a4.2 4.2 0 0 0 2.4 2.3 5 5 0 0 0 5.4-1.3l1 1.7ZM341.2 125.8h11.3v2.2H348v10.4h-2.2V128h-4.6v-2.2ZM355 125.8h2.3v1.4c.4-.5 1-.9 1.7-1.2a6 6 0 0 1 2.5-.5c.9 0 1.7.1 2.4.5a5.3 5.3 0 0 1 3 3.3 8 8 0 0 1 0 5.3 6.3 6.3 0 0 1-3.4 3.6c-.8.3-1.7.5-2.7.5-.7 0-1.3 0-2-.2-.6-.2-1.1-.4-1.5-.7v6.2H355v-18.2Zm5.9 1.8c-.8 0-1.5.1-2.1.5-.6.3-1.2.7-1.5 1.2v6.3a5.4 5.4 0 0 0 3.3 1c.7 0 1.3-.1 1.8-.4a4 4 0 0 0 2.2-2.4 5.6 5.6 0 0 0 0-3.6c-.1-.5-.4-1-.7-1.4-.4-.4-.8-.7-1.3-.9-.5-.2-1-.3-1.7-.3ZM370.4 125.8h2.3v3.8h2.1c1 0 1.8 0 2.5.3.6.3 1.1.6 1.5 1 .4.4.7.8.8 1.4a5.5 5.5 0 0 1 0 3.2c-.2.6-.5 1-.9 1.5-.4.4-1 .7-1.6 1-.7.2-1.5.4-2.5.4h-4.2v-12.6Zm2.3 5.9v4.6h1.7c1.1 0 1.9-.2 2.4-.6.4-.4.7-1 .7-1.7 0-.8-.3-1.4-.8-1.8-.4-.3-1.2-.5-2.3-.5h-1.7Zm9.6-6h2.3v12.7h-2.3v-12.6ZM395.2 131.9l4.8 6.5h-2.8l-3.7-5.1-3.8 5h-2.6l4.8-6.3-4.5-6.2h2.8l3.4 4.7 3.5-4.7h2.6l-4.5 6ZM199 154h-6.8v10.5h-2.3v-12.6h11.4v12.6H199V154ZM213.8 154h-4.4l-.1 2.2c-.2 1.8-.4 3.2-.7 4.3a8 8 0 0 1-1 2.5c-.5.6-1 1-1.5 1.2l-1.8.3-.2-2.2c.2 0 .5 0 .8-.2.3-.1.6-.4 1-.9a16.8 16.8 0 0 0 1.3-5.5l.1-3.8h8.7v12.4h-2.2v-10.2ZM220.2 152.7a8.5 8.5 0 0 1 4.2-1.1c1.8 0 3 .4 3.8 1.3.7.9 1 2.1 1 3.8v7.6h-2v-1.6a5 5 0 0 1-1.6 1.2c-.6.4-1.5.6-2.5.6a4 4 0 0 1-2.8-1c-.8-.7-1.1-1.7-1.1-2.9 0-.6.1-1.2.3-1.7.3-.5.6-.9 1-1.2l1.6-.8 1.9-.2 1.6.1c.6.2 1.1.4 1.5.7v-1.6c-.1-.5-.3-1-.5-1.2a2 2 0 0 0-.8-.8c-.4-.2-1-.3-1.5-.3-.8 0-1.5 0-2 .2l-1.5.7-.6-1.8Zm3.7 9.8c.8 0 1.5-.2 2-.5l1.2-1.1v-1.6a4.8 4.8 0 0 0-3.8-.7c-.3 0-.6.2-.9.4l-.6.6-.2 1c0 .5.2 1 .6 1.3.4.4 1 .6 1.7.6ZM231.4 151.9h11.4v2.2h-4.6v10.4H236V154h-4.6V152ZM255.4 162.8c-.6.6-1.3 1-2.2 1.3a8.4 8.4 0 0 1-5.2 0c-.9-.4-1.6-.8-2.2-1.4-.5-.6-1-1.2-1.3-2a7.3 7.3 0 0 1 0-5.2 5.9 5.9 0 0 1 3.2-3.4 7 7 0 0 1 5-.1 5.5 5.5 0 0 1 3.1 3c.3.6.5 1.4.5 2.2 0 .6 0 1-.2 1.5h-9.6c.1 1.2.6 2 1.4 2.7.8.7 1.8 1 3 1 .8 0 1.5-.1 2.2-.4a5 5 0 0 0 1.6-.9l.7 1.7Zm-5-9.2a4 4 0 0 0-2.8 1c-.7.6-1 1.4-1.2 2.3h7.6c0-1-.4-1.8-1-2.4-.7-.6-1.5-.9-2.6-.9ZM257.5 151.9h2.8l4.3 6-4.6 6.6h-2.8l4.9-6.5-4.6-6.1Zm7.7 0h2.2v12.6h-2.2v-12.6Zm5.3 6 5 6.6h-2.8L268 158l4.4-6.1h2.7l-4.6 6ZM287.8 162.8c-.6.6-1.3 1-2.2 1.3a8.4 8.4 0 0 1-5.3 0c-.8-.4-1.5-.8-2-1.4-.6-.6-1.1-1.2-1.4-2a7.3 7.3 0 0 1 0-5.2 5.8 5.8 0 0 1 3.2-3.4 7 7 0 0 1 5-.1 5.5 5.5 0 0 1 3.1 3c.3.6.5 1.4.5 2.2 0 .6 0 1-.2 1.5H279c.1 1.2.6 2 1.4 2.7.7.7 1.8 1 3 1 .8 0 1.5-.1 2.2-.4a5 5 0 0 0 1.6-.9l.7 1.7Zm-5-9.2a4 4 0 0 0-2.8 1c-.7.6-1 1.4-1.2 2.3h7.6c0-1-.4-1.8-1-2.4-.7-.6-1.6-.9-2.6-.9ZM291.5 164.5v-12.7h2.3v9.4l7.4-9.4h2.3v12.7h-2.3V155l-7.4 9.5h-2.3Zm4-19.2c0 1.5.8 2.2 2.2 2.2 1.2 0 2-.7 2-2.2h2.2l-.3 1.5c-.2.5-.5 1-.9 1.3a4.2 4.2 0 0 1-3 1.1c-.7 0-1.4 0-2-.3a4 4 0 0 1-1.3-.8l-.8-1.3c-.2-.4-.3-1-.3-1.5h2.2Z" clipRule="evenodd"></path></svg>
        </div>
    )

    if (currentSubpage == SUBPAGE_COMPLETE) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>
        
                {sbpLogo}

                    <div className={styles.statusWrapper}>
                        <CheckCircleIcon fontSize="large" style={{ color: "green" }}/>            
                        <div><b>Платеж успешно выполнен</b></div>
                    </div>
                </div>
            </div> 
        )        
    } else if (currentSubpage == SUBPAGE_FAILED) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>
        
                {sbpLogo}
                <div className={styles.statusWrapper}>
                    <CancelIcon fontSize="large" style={{ color: "red" }}/>     
                    <p><b>Произошла ошибка при проведении платежа</b></p>
                </div>                    
                </div>
            </div> 
        )  
    } else if (currentSubpage == SUBPAGE_PENDING) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>
        
                {sbpLogo}

                <div className={styles.waitForStatusCircularProgressWrapper}>                
                    <CircularProgress
                        className={styles.waitForStatusCircularProgress}
                        size={120}
                        thickness={3}
                    />
                </div>

                <div className={styles.selectBankHeaderWrapper}>
                    <p><b>Ожидаем подтвержение платежа. </b></p>

                    <p><b> Хотите оплатить используя друй банк? Нажмите "оплатить"</b></p>
                </div>

                <div className={styles.payButonWrapper}>
                    <Button variant="contained" color="primary" onClick={event => setCurrentSubpage(false)}>
                    оплатить
                    </Button>
                </div>
                </div>
            </div>
        )
    }
    else if (isMobile() || payHere) {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>
        
                {sbpLogo}

                <div className={styles.selectBankHeaderWrapper}>
                    <b>Выберите банковское приложение и подтвердите оплату</b>
                    </div>

                    <div>
                    <InputBase
                        className={styles.selectBankSearch}
                        placeholder="Поиск"
                        value={bankFilter}
                        onChange={event => setBankFilter(event.target.value.toLowerCase())}
                    />
                    </div>

                    <div className={styles.selectBankHeaderWrapper}>
                    <b>Все банки</b>
                    </div>

                    {!!banks &&
                        <List className={styles.selectBankListWrapper}>
                            {banks}
                        </List>
                    }
                </div>
            </div>
        )
    } else {
        return (
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>

                    {sbpLogo}

                    <div>
                        Для оплаты с мобильного устройства, пожалуйста отсканируйте QR-код:
                    </div>

                    <div className={styles.qr}>
                    <QRCode value={url} size={300} />
                    </div>

                    <div>
                        Хотите оплатить на этом устройстве?                    
                    </div>
                    <div className={styles.payButonWrapper}>
                        <Button variant="contained" color="primary" onClick={event => setPayHere(true)}>
                        Оплатить
                        </Button>
                    </div>
                </div>

            </div>
        )
    }   
}